<ng-template #analysisOptionsDialog>
    <div
        style=" background-color: #F3F3F5;width: 100%; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
        <button class="close-button" mat-dialog-close>
            <img src="./assets/images/close-icon.svg">
        </button>
    </div>


    <mat-dialog-content class="box-content">
        <div class="main-box-title-32" style="margin-bottom: 20px ;"> Choose Your Data To Export</div>
        <div class="main-box-title-18" style="margin-bottom: 20px ;">The data will be exported as individual rows, with
            columns representing each document in the workflow.</div>
        <div style="width: 100%; margin-bottom: 15px;">
            <mat-checkbox [(ngModel)]="selectAllChecked" (change)="toggleSelectAll()">
                Select All
            </mat-checkbox>
        </div>
        <div class="box-expanded-advanced">

            <ng-container *ngIf="isScreenLarge; else mobileLayout">


                <div class="left-list">
                    <!-- <mat-checkbox  [(ngModel)]="a_exportar[0]" disableRipple >Summary</mat-checkbox> -->
                    <!-- <mat-checkbox  [(ngModel)]="a_exportar[1]" disableRipple >Readability</mat-checkbox> -->
                    <mat-checkbox [(ngModel)]="a_exportar[0]" (change)="updateSelectAllState()"
                        disableRipple>Statistics</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[1]" (change)="updateSelectAllState()"
                        disableRipple>Errors</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[2]" (change)="updateSelectAllState()" disableRipple>Lexical
                        Diversity</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[3]" (change)="updateSelectAllState()"
                        disableRipple>Tagger</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[4]" (change)="updateSelectAllState()"
                        disableRipple>KVL</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[5]" (change)="updateSelectAllState()"
                        disableRipple>EVP</mat-checkbox>
                </div>
                <div class="right-list">
                    <mat-checkbox *ngIf="englishType == 'american'" [(ngModel)]="a_exportar[6]" (change)="updateSelectAllState()"
                        disableRipple>COCA</mat-checkbox>
                    <mat-checkbox *ngIf="englishType == 'british'" [(ngModel)]="a_exportar[7]" (change)="updateSelectAllState()"
                        disableRipple>BNC</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[8]" (change)="updateSelectAllState()"
                        disableRipple>AWL</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[9]" (change)="updateSelectAllState()"
                        disableRipple>Metadiscourse</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[10]" (change)="updateSelectAllState()"
                        disableRipple>Scorecard</mat-checkbox>
                </div>
            </ng-container>

            <!----------->
            <!-- MOBIL -->
            <!----------->

            <ng-template #mobileLayout>
                <div class="left-list">
                    <!-- <mat-checkbox  [checked]="true" disableRipple >Summary</mat-checkbox> -->
                    <!-- <mat-checkbox  [(ngModel)]="a_exportar[1]" disableRipple >Readability</mat-checkbox> -->
                    <mat-checkbox [(ngModel)]="a_exportar[0]"  (change)="updateSelectAllState()" disableRipple>Statistics</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[1]"  (change)="updateSelectAllState()" disableRipple>Errors</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[2]"  (change)="updateSelectAllState()" disableRipple>
                        <p style="text-align: left;">Lexical Diversity</p>
                    </mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[3]" (change)="updateSelectAllState()" disableRipple>Tagger</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[4]"  (change)="updateSelectAllState()" disableRipple>KVL</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[5]"  (change)="updateSelectAllState()" disableRipple>EVP</mat-checkbox>
                </div>
                <div class="right-list">
                    <mat-checkbox *ngIf="englishType == 'american'" [(ngModel)]="a_exportar[6]"  (change)="updateSelectAllState()" disableRipple>COCA</mat-checkbox>
                    <mat-checkbox *ngIf="englishType == 'british'" [(ngModel)]="a_exportar[7]"  (change)="updateSelectAllState()" disableRipple>BNC</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[8]"  (change)="updateSelectAllState()" disableRipple>AWL</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[9]"  (change)="updateSelectAllState()" disableRipple>Metadiscourse</mat-checkbox>
                    <mat-checkbox [(ngModel)]="a_exportar[10]"  (change)="updateSelectAllState()" disableRipple>Scorecard</mat-checkbox>
                </div>

            </ng-template>


        </div>
        <div class="box-button">
            <button mat-button class="analysis-button" (click)='exportar_datos()'><span class="main-box-title-16"
                    style="font-weight: 600;">Export To CSV </span> </button>
        </div>
    </mat-dialog-content>
</ng-template>